<template>
    <div>
        <div v-if="items && items.length">
            <div style="color: #aaa;margin-bottom: 10px;" v-if="!nohead">操作日志</div>
            <div class="scroll-none" style="overflow: scroll;overflow-y: hidden; display: grid; width: 100%; padding-bottom: 20px">
                <div style="display: flex;">
                    <div v-for="(item,index) in items" :key="index" style="border-radius: 4px;border: 1px solid #eee;width: 200px;margin-right: 10px;">
                        <div style="background-color: #f8f8f8;padding: 10px;font-weight: bold;border-bottom: 1px solid #eee;">{{item.title}}</div>
                        <div style="padding: 10px;">
                            <div>操作者：{{item.zhanghao.name}}</div>
                            <div>时间：{{item.createTimeStr}}</div>
                            <div v-if="item.beizhu">备注：{{item.beizhu}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 20px;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            },
            nohead: Boolean
        },
        data() {
            return {}
        },
        mounted() { },
        methods: {},
        created() { },
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/Caozuojilu.vue?5337cd5a